import React from 'react';
import {Container, Row, Col, Media} from 'reactstrap';
import moment from 'moment';
import profile from '../profile.json';

import oca_admin from '../O_Database12c_Admin_Associate_clr.gif';
import oca_sql from '../O-CertAssoc-O-DB-SQL-clr.gif';

let imagelogo ={
    oca_admin, oca_sql
};


class Certifications extends React.Component {
  render() {
    return <Container>
        <Row>
            <Col>
                {profile.certifications.map(function (certification, i) {
                const verification = certification.verificationLink ?
                    <Row>
                    <Col>
                        <a className="certificateLink" href={certification.verificationLink}>See certificate</a>
                    </Col>
                    </Row> : "";
                return <Media key={i}>
                    <Media left top href={certification.url}>
                    <Media object src={imagelogo[certification.logo]} style={{width:"77.5px", height:"67.5px"}} alt={certification.title}/>
                    </Media>
                    <Media body>
                    <Media heading>
                        <a href={certification.url}>{certification.title}</a>
                    </Media>
                    <Row>
                        <Col>{moment(certification.issueDate).format('MMM YYYY')} - {(certification.expiryDate) ? moment(certification.expiryDate).format('MMM YYYY') : 'Present'}</Col>
                    </Row>
                    <Row>
                        <Col>{certification.issuer}</Col>
                    </Row>
                    {verification}
                    </Media>
                </Media>
                })}
            </Col>
        </Row>
    </Container>
  }
} 

export default Certifications;